<template>
	<div class="sub-menu" :class="cssClass">
		<div class="links" :class="cssClass" @click="closeMenu()">
			<div>
				<router-link :to="{ name: 'WatchDashboard', params: { user_uid: user_uid, watch_id: watch_id } }">
					<svgicon name="dashboard" :fill="false"></svgicon>
					<span>{{ $t('base.general.dashboard') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchBiometric', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:biometric="watch_id">
					<svgicon name="graph biometric" :fill="false"></svgicon>
					<span>{{ $t('base.watch.biometric') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchGeofencing', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:geofencing="watch_id">
					<svgicon name="geo fencing" :fill="false"></svgicon>
					<span>{{ $t('base.watch.geofencing') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchPills', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:pillbox="watch_id">
					<svgicon name="pills2" :fill="false"></svgicon>
					<span>{{ $t('base.watch.pillbox') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchAppointments', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:appointments="watch_id">
					<svgicon name="sethoscope" :fill="false"></svgicon>
					<span>{{ $t('base.watch.appointments') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchHealthReports', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:healthreports="watch_id">
					<svgicon name="health report" :fill="false"></svgicon>
					<span>{{ $t('base.watch.healthreports') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchMedicalDocuments', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:medicaldocuments="watch_id">
					<svgicon name="medical doc" :fill="false"></svgicon>
					<span>{{ $t('base.watch.medicaldocs') }}</span>
				</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'WatchProfile', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:patient_profile="watch_id">
					<svgicon name="user" :fill="false"></svgicon>
					<span>{{ $t('base.watch.profile') }}</span>
				</router-link>
			</div>
			<!-- <div>
				<router-link :to="{ name: 'WatchChat', params: { user_uid: user_uid, watch_id: watch_id } }"
					v-check-watch:chat="watch_id">
					<svgicon name="chat" :fill="false"></svgicon>
					<span>{{ $t('base.watch.chat') }}</span>
				</router-link>
			</div> -->
		</div>
	</div>
</template>

<script>
import scroller from '@/utils/scroller'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			open: false
		}
	},
	computed: {
		cssClass () {
			return this.open ? 'open' : ''
		},
		btnIcon () {
			return this.open ? 'closing' : 'menu'
		}
	},
	methods: {
		openMenu () {
			this.open = !this.open
		},
		closeMenu () {
			this.open = false
		}
	},
	mounted () {
		this.$root.$on('open-submenu', this.openMenu)
		this.$root.$on('close-submenu', this.closeMenu)
		scroller()
	},
	beforeDestroy () {
		this.$root.$off('open-submenu', this.openMenu)
		this.$root.$off('close-submenu', this.closeMenu)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/SubMenu.vue